<footer id="footer" class="footer" itemscope itemtype="https://schema.org/WPFooter">
  <div class="footerBody">
    <vc-footer-nav-section [navigations]="(footerData$ | async)?.navigation" [home]="isHome"></vc-footer-nav-section>

    <div class="footerEssentials innerContainer">
      <vc-footer-social-section
        [socials]="(footerData$ | async)?.socials"
        [home]="isHome"
        class="footer__social"
      ></vc-footer-social-section>

      <div class="footer_apps" *ngIf="lang">
        <vc-ref
          resource="https://app.adjust.com/2ep0vf"
          [blank]="true"
          [anchor]="false"
          class="footer__appsBtn footer__appsBtn--google"
          ><!--
          --><img
            class="footer__appsBtnImg"
            loading="lazy"
            src="https://vestiairecollective-assets.imgix.net/pages/applications/google/google_{{
              lang.substr(0, 2)
            }}.png?w=140&q=70&auto=format&dpr=2"
            width="140"
            i18n-alt="@@FOOTER.GET_ANDROID_APP"
            alt="Download on the Google Play Store"
          /><!----></vc-ref
        ><!--
        --><vc-ref
          resource="https://app.adjust.com/xa7pe2"
          [blank]="true"
          [anchor]="false"
          class="footer__appsBtn footer__appsBtn--apple"
          ><!--
          --><img *ngIf="lang === 'fr-FR'" class="footer__appsBtnImg" src="/assets/svg/app-apple-fr.svg" alt="" /><!--
          --><img *ngIf="lang === 'de-DE'" class="footer__appsBtnImg" src="/assets/svg/app-apple-de.svg" alt="" /><!--
          --><img *ngIf="lang === 'es-ES'" class="footer__appsBtnImg" src="/assets/svg/app-apple-es.svg" alt="" /><!--
          --><img *ngIf="lang === 'it-IT'" class="footer__appsBtnImg" src="/assets/svg/app-apple-it.svg" alt="" /><!--
          --><img *ngIf="lang === 'en-GB'" class="footer__appsBtnImg" src="/assets/svg/app-apple-uk.svg" alt="" /><!--
          --><img *ngIf="lang === 'en-US'" class="footer__appsBtnImg" src="/assets/svg/app-apple-us.svg" alt="" /><!--
        --></vc-ref>
      </div>

      <div class="footer__internationalisation">
        <div mat-raised-button vcOpenI18nPopin>
          <div type="button" class="i18n__choices js-getUserInfo_i18n js-openPopin_i18n">
            {{ i18nvalue }}
          </div>
        </div>
      </div>

      <vc-footer-legals
        class="footer__legals"
        [legals]="(footerData$ | async)?.legals"
        [home]="isHome"
        [showAccessibilityLink]="showAccessibilityLink"
      ></vc-footer-legals>
    </div>
  </div>

  <div class="footerBottom">
    <vc-footer-disclaimer class="footer__disclaimer" *ngIf="showDisclaimer"></vc-footer-disclaimer>
    <vc-footer-copyright
      class="footer__copyright"
      [home]="isHome"
      [pagetype]="pageType"
      [domainsLinks]="(footerData$ | async)?.domainsLinks"
    ></vc-footer-copyright>
    <vc-footer-payment-mode class="footer__paymentMode"></vc-footer-payment-mode>
  </div>
</footer>
